import * as React from 'react';
import {run} from "../fbobjects/framework/testing";



export default class Testing extends React.Component<any,any> {

	constructor(){
		super();
		run();
	}

	render(){
		return(
			<div style={{position:"relative"}}>
				<img src="http://orig01.deviantart.net/ddaa/f/2014/212/5/4/concept_art34_by_zulusplitter-d7t29b3.jpg" />
			</div>

		)
	}
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Testing.tsx